import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoginUser, reset } from "../features/authSlice";
import Modal from 'react-modal';
import kumbhImage from '../kumbh.jpg';
import Navbar from "./Navbar";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError, isSuccess, isLoading, message } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (user || isSuccess) {
      navigate("/dashboard");
    }
    dispatch(reset());
  }, [user, isSuccess, dispatch, navigate]);

  const Auth = (e) => {
    e.preventDefault();
    dispatch(LoginUser({ email, password }));
  };

  const handleModalClose = () => {
    setModalIsOpen(false);
    navigate("/");
  };

  return (
    <div>
    <Navbar/>
      <div className="image-container">
        <img src={kumbhImage} alt="Home Background"/>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleModalClose}
        contentLabel="Login"
        className="custom-modal"
        overlayClassName="custom-modal-overlay"
        shouldCloseOnOverlayClick={true}
      >
        <div className="modal-header" id="modalheader">
          <h1 className="modal-title">Sign In</h1>
        </div>
        <div className="modal-body" id="modalbody">
          <form onSubmit={Auth} className="box">
            {isError && <p className="has-text-centered">{message}</p>}
            <div className="field">
              <label className="label">Email</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                />
              </div>
            </div>
            <div className="field">
              <label className="label">Password</label>
              <div className="control">
                <input
                  type="password"
                  className="input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="******"
                />
              </div>
            </div>
            <div className="field mt-5">
              <button
                type="submit"
                className="button is-success is-fullwidth"
              >
                {isLoading ? "Loading..." : "Login"}
              </button>
            </div>
          </form>
        </div>
        <div className="modal-footer" id="modalfooter">
          {/* <button className="close-button" onClick={handleModalClose}>Close</button> */}
        </div>
      </Modal>
    </div>
  );
};

export default Login;
